/*
 * @prop --component-tab-color: text color of tab
 * @prop --component-tab-active-color: text color of active tab
*/

:host {
  display: inline-block;
  background-color: var(--skin-color-secondary-lighter, $ui-grey-minus-3);
  border: 1px solid var(--skin-color-secondary, $ui-grey);
  border-bottom: 0;
  bottom: 1px;
  border-radius: 5px 5px 0 0;
  cursor: pointer;
  font-weight: $font-weight-bold;
  margin-right: 5px;
  position: relative;
  width: auto;
  z-index: 1;
  box-sizing: border-box;

  a {
    display: inline-block;
    padding: 17px 28px;
    color: var(--component-tab-color, var(--skin-color-primary, $ui-blue));

    &:hover {
      color: var(--skin-color-primary-light, $ui-blue-minus-1);
    }
  }
}

:host(.active) {
  background-color: var(--skin-color-white, $ui-white);
  cursor: default;

  &::after {
    content: '';
    height: 2px;
    background-color: var(--skin-color-white, $ui-white);
    width: 100%;
    position: absolute;
    bottom: -2px;
    left: 0;
    z-index: 1;
  }

  a {
    color: var(
      --component-tab-active-color,
      var(--skin-color-accent, $ui-green)
    );
  }
}

:host(:hover) {
  background-color: var(--skin-color-secondary-light, $ui-grey-minus-2);
}

:host(.active:hover) {
  background-color: var(--skin-color-white, $ui-white);
}
